import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface NodeConfigDrawerProps {
  onClose: () => void;
  title: string;
  subtitle?: string;
  /** Kept for API compatibility with callers; the drawer chrome is monochrome. */
  nodeColor: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  wide?: boolean;
}

export const NodeConfigDrawer: React.FC<NodeConfigDrawerProps> = ({
  onClose,
  title,
  subtitle,
  nodeColor,
  icon,
  children,
  wide = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col bg-muted">
      {/* Header bar */}
      <div className="flex shrink-0 items-center gap-3 border-b bg-background px-6 py-2.5">
        <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-muted">
          {icon}
        </span>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-medium text-foreground">{title}</p>
          {subtitle && (
            <p className="truncate text-xs text-muted-foreground">{subtitle}</p>
          )}
        </div>
        <Button
          variant="ghost"
          size="icon-sm"
          onClick={onClose}
          aria-label={t('COMMON.CANCEL')}
        >
          <X className="size-4" />
        </Button>
      </div>

      {/* Content area */}
      <div className="flex-1 overflow-y-auto px-6 py-5">
        <div className="rounded-xl border bg-background p-6">
          {children}
        </div>
      </div>
    </div>
  );
};
